// 🔧 volunteer_activity_defaults.js
// ✅ Purpose: Provides default volunteer activities for Demo Engine events
// ✅ Features:
// - Industry-aware volunteer activity templates
// - Returns plain JavaScript objects only
// - No Firestore access
// - No DemoContext mutation
// - Shared by Volunteer Generator
// - Fully block-commented for clarity and future devs

// =====================================================
// 🚗 Car Show Activity Template
// =====================================================

const CAR_SHOW_ACTIVITIES = [
  {
    id: "registration",
    title: "Registration",
    description:
      "Welcome participants, verify registrations, distribute packets, and answer questions.",
    displayOrder: 10,
  },
  {
    id: "parking",
    title: "Parking Assistance",
    description:
      "Direct arriving vehicles to their assigned parking locations.",
    displayOrder: 20,
  },
  {
    id: "judging",
    title: "Judging Support",
    description:
      "Assist judges by coordinating score sheets and directing vehicle flow.",
    displayOrder: 30,
  },
  {
    id: "information",
    title: "Information Booth",
    description:
      "Provide schedules, maps, and event information to attendees.",
    displayOrder: 40,
  },
  {
    id: "merchandise",
    title: "Merchandise",
    description:
      "Assist guests with event merchandise purchases and inventory.",
    displayOrder: 50,
  },
  {
    id: "awards",
    title: "Awards Ceremony",
    description:
      "Prepare awards, organize winners, and assist during presentations.",
    displayOrder: 60,
  },
];

// =====================================================
// 🎨 Art Show Activity Template
// =====================================================

const ART_SHOW_ACTIVITIES = [
  {
    id: "gallery",
    title: "Gallery Host",
    description:
      "Welcome visitors and answer questions about the exhibit.",
    displayOrder: 10,
  },
  {
    id: "artists",
    title: "Artist Assistance",
    description:
      "Help artists with setup and visitor interactions.",
    displayOrder: 20,
  },
  {
    id: "sales",
    title: "Sales Desk",
    description:
      "Assist with artwork purchases and checkout.",
    displayOrder: 30,
  },
  {
    id: "information",
    title: "Information Booth",
    description:
      "Provide event information and schedules.",
    displayOrder: 40,
  },
];

// =====================================================
// 🐶 Pet Show Activity Template
// =====================================================

const PET_SHOW_ACTIVITIES = [
  {
    id: "checkin",
    title: "Pet Check-in",
    description:
      "Assist participants during registration and arrival.",
    displayOrder: 10,
  },
  {
    id: "ring",
    title: "Ring Assistant",
    description:
      "Coordinate participants entering and exiting the competition ring.",
    displayOrder: 20,
  },
  {
    id: "hospitality",
    title: "Hospitality",
    description:
      "Support visitors with refreshments and information.",
    displayOrder: 30,
  },
];

// =====================================================
// 🏫 School Election Template
// =====================================================

const SCHOOL_ELECTION_ACTIVITIES = [
  {
    id: "pollworker",
    title: "Poll Worker",
    description:
      "Assist students with the voting process and answer questions.",
    displayOrder: 10,
  },
  {
    id: "greeter",
    title: "Entrance Greeter",
    description:
      "Welcome students and direct them to voting stations.",
    displayOrder: 20,
  },
  {
    id: "results",
    title: "Results Team",
    description:
      "Assist administrators with election closing procedures.",
    displayOrder: 30,
  },
];

// =====================================================
// Build activities
// =====================================================

export const buildVolunteerActivities = ({
  industryTemplate = "car_show",
} = {}) => {
  switch (industryTemplate) {
    case "art_show":
      return [...ART_SHOW_ACTIVITIES];

    case "pet_show":
      return [...PET_SHOW_ACTIVITIES];

    case "school_election":
      return [...SCHOOL_ELECTION_ACTIVITIES];

    case "car_show":
    default:
      return [...CAR_SHOW_ACTIVITIES];
  }
};